import styled from 'styled-components'

export const CartTotalContainer = styled.div`
  background-color: white;
  padding: 15px;
`

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: grey;
`

export const TotalTotal = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

